import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { serviceAPI, categoryAPI } from '../utils/api';
import './CreateService.css';

export default function CreateService() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    title: '', description: '', price: '', priceType: 'fixed',
    categoryId: '', tags: '', deliveryTime: '', city: '', state: '', country: 'US',
  });

  useEffect(() => {
    categoryAPI.getAll().then(r => setCategories(r.data)).catch(() => {});
  }, []);

  const handleChange = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        ...form,
        price: parseFloat(form.price),
        tags: form.tags ? form.tags.split(',').map(t => t.trim().toLowerCase()).filter(Boolean) : [],
      };
      const { data: svc } = await serviceAPI.create(data);
      toast.success('Service created successfully!');
      navigate(`/dashboard/seller/edit/${svc.id}`);
    } catch (err) {
      toast.error(err.response?.data?.error?.message || 'Failed to create service');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-service-page page">
      <div className="container">
        <div className="create-header">
          <h1>Create New Service</h1>
          <p className="text-light">Fill in the details below to list your service on African Marketplace.</p>
        </div>

        <form onSubmit={handleSubmit} className="create-form">
          <div className="create-section">
            <h2>📋 Basic Information</h2>
            <div className="form-group">
              <label className="form-label">Service Title *</label>
              <input type="text" name="title" className="form-input" placeholder="e.g. West African Jollof Rice Catering"
                value={form.title} onChange={handleChange} required maxLength={120} />
              <span className="form-hint">Be specific and clear. {120 - form.title.length} characters remaining.</span>
            </div>
            <div className="form-group">
              <label className="form-label">Description *</label>
              <textarea name="description" className="form-textarea" style={{ minHeight: 160 }}
                placeholder="Describe your service in detail — what you offer, your experience, what customers can expect..."
                value={form.description} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label className="form-label">Category *</label>
              <select name="categoryId" className="form-select" value={form.categoryId} onChange={handleChange} required>
                <option value="">Select a category...</option>
                {categories.map(c => <option key={c.id} value={c.id}>{c.icon} {c.name}</option>)}
              </select>
            </div>
          </div>

          <div className="create-section">
            <h2>💰 Pricing</h2>
            <div className="price-row">
              <div className="form-group" style={{ flex: 1 }}>
                <label className="form-label">Price (USD) *</label>
                <input type="number" name="price" className="form-input" placeholder="0.00"
                  value={form.price} onChange={handleChange} min="0" step="0.01" required />
              </div>
              <div className="form-group" style={{ flex: 1 }}>
                <label className="form-label">Price Type</label>
                <select name="priceType" className="form-select" value={form.priceType} onChange={handleChange}>
                  <option value="fixed">Fixed Price</option>
                  <option value="hourly">Per Hour</option>
                  <option value="starting_at">Starting At</option>
                </select>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Estimated Delivery / Turnaround Time</label>
              <input type="text" name="deliveryTime" className="form-input" placeholder="e.g. Same day, 1–2 days, 1 week"
                value={form.deliveryTime} onChange={handleChange} />
            </div>
          </div>

          <div className="create-section">
            <h2>📍 Location</h2>
            <div className="location-row">
              <div className="form-group">
                <label className="form-label">City</label>
                <input type="text" name="city" className="form-input" placeholder="e.g. Houston"
                  value={form.city} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">State</label>
                <input type="text" name="state" className="form-input" placeholder="e.g. TX"
                  value={form.state} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label className="form-label">Country</label>
                <input type="text" name="country" className="form-input" placeholder="e.g. US"
                  value={form.country} onChange={handleChange} />
              </div>
            </div>
          </div>

          <div className="create-section">
            <h2>🏷️ Tags</h2>
            <div className="form-group">
              <label className="form-label">Tags (comma-separated)</label>
              <input type="text" name="tags" className="form-input"
                placeholder="e.g. jollof rice, catering, west african, party food"
                value={form.tags} onChange={handleChange} />
              <span className="form-hint">Tags help customers find your service more easily.</span>
            </div>
          </div>

          <div className="create-actions">
            <button type="button" className="btn btn-ghost" onClick={() => navigate('/dashboard/seller')}>Cancel</button>
            <button type="submit" className="btn btn-primary btn-lg" disabled={loading}>
              {loading ? '⏳ Creating...' : '✅ Create Service'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
